import React from 'react';
import { TypedMemo } from '../../common/types';
import { SmartLinksNavbar } from '../smartLinksNavbar/SmartLinksNavbar';
import { PublicModeBanner } from '../smlContainer/PublicModeBanner';

const SmartLinksContainerRendererComponent: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <>
      <SmartLinksNavbar />
      <PublicModeBanner />
      {children}
    </>
  );
};

export const SmartLinksContainerRenderer = TypedMemo(SmartLinksContainerRendererComponent);
